import { render, staticRenderFns } from "./chiffrage-prise-en-charge-assurance-proprietaire.vue?vue&type=template&id=66e5397b&scoped=true"
import script from "./chiffrage-prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"
export * from "./chiffrage-prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5397b",
  null
  
)

export default component.exports